// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#intercom-container .intercom-launcher-frame,\n#intercom-container .intercom-launcher-discovery-frame {\n  display: none;\n}\n.intercom-lightweight-app {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
